var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "check-exam-status" }, [
    _c(
      "div",
      { staticClass: "exam-header" },
      [
        _c(
          "el-row",
          { attrs: { type: "flex", justify: "space-between" } },
          [
            _c(
              "el-col",
              { staticClass: "exam-title", attrs: { span: 8 } },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "light",
                      content: _vm.examInfo.manageName,
                      placement: "right",
                    },
                  },
                  [_c("h3", [_vm._v(_vm._s(_vm.examInfo.manageName))])]
                ),
              ],
              1
            ),
            _c("el-col", { attrs: { span: 8 } }, [
              !_vm.isDingding
                ? _c("div", { staticClass: "goback" }, [
                    _c("i", {
                      staticClass: "iconfont icon-guanbi2",
                      attrs: { title: "关闭" },
                      on: { click: _vm.closePage },
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "closeitem",
                        on: { click: _vm.closePage },
                      },
                      [_vm._v("关闭")]
                    ),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "exam-main" }, [
      _c("div", { staticClass: "result-wrapper" }, [
        _c(
          "div",
          { staticClass: "status-info" },
          [
            _c("div", { staticClass: "exam-user" }, [
              _c(
                "div",
                { staticClass: "exam-user-photo" },
                [
                  _vm.examInfo.userId
                    ? _c("el-avatar", {
                        attrs: {
                          size: 100,
                          src:
                            "/oua2/getUserPhoto?type=relativePath&userId=" +
                            _vm.examInfo.userId,
                        },
                        on: { error: _vm.errorHandler },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "exam-user-name" }, [
                _c("span", [_vm._v(_vm._s(_vm.examInfo.userName))]),
              ]),
            ]),
            _c(
              "el-tooltip",
              {
                staticClass: "item",
                attrs: {
                  effect: "light",
                  content: _vm.examInfo.manageName,
                  placement: "top",
                },
              },
              [
                _c("div", { staticClass: "exam-title" }, [
                  _c("p", [_vm._v(_vm._s(_vm.examInfo.manageName))]),
                ]),
              ]
            ),
            _c("div", { staticClass: "exam-dividing-line" }),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "exam-scors-wrapperpass" }, [
                _vm.examInfo.isPass === "0" || _vm.examInfo.isPass === "1"
                  ? _c("div", [
                      _vm._v(" 考试成绩"),
                      _c(
                        "span",
                        {
                          staticClass: "exam-scors",
                          class: {
                            "exam-scors-fail": _vm.examInfo.isPass === "0",
                            "exam-scors-pass": _vm.examInfo.isPass === "1",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.examInfo.showText))]
                      ),
                    ])
                  : _vm.examInfo.isPass === "不公布"
                  ? _c("div", [
                      _c("span", { staticClass: "exam-scors" }, [
                        _vm._v(" " + _vm._s(_vm.examInfo.showText)),
                      ]),
                    ])
                  : _c("div", [_c("span", [_vm._v(_vm._s("暂无成绩"))])]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "table-content" },
              [
                _c(
                  "el-table",
                  {
                    ref: "singleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      "max-height": "350",
                      data: _vm.examInfo.presentScoreList,
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "次数", width: "90" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(" 第" + _vm._s(scope.row.time) + "次 "),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "成绩", width: "90", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.status === "完成"
                                ? _c("span", [
                                    _vm._v(_vm._s(scope.row.showText)),
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row.status)),
                                  ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        property: "examDatetimeEdate",
                        label: "交卷时间",
                        width: "200",
                        "show-overflow-tooltip": true,
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { width: "140", label: "操作", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.status === "进行中" &&
                              _vm.examing === true
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        size: "small",
                                        disabled: _vm.isTeacher,
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.continueExam(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.isTeacher ? "" : "继续考试"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.checkDetails(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 查看详情 ")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        !_vm.isTeacher
          ? _c("div", { staticClass: "exam-button-bar" }, [
              _vm.examInfo.status !== "历史" &&
              _vm.examInfo.remainNum !== "0" &&
              _vm.examing === false
                ? _c(
                    "div",
                    {
                      staticClass: "exam-button-item",
                      on: { click: _vm.tryAgain },
                    },
                    [
                      _vm.examInfo.infinite === true
                        ? _c("span", [_vm._v("再考一次(不限次)")])
                        : _vm.examInfo.infinite === false
                        ? _c("span", [
                            _vm._v(
                              "再考一次(" +
                                _vm._s(_vm.examInfo.remainNum) +
                                "次)"
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm.examing === true
                ? _c(
                    "div",
                    {
                      staticClass: "exam-button-item",
                      on: { click: _vm.continueExam },
                    },
                    [_vm._v("继续考试")]
                  )
                : !_vm.isDingding
                ? _c(
                    "div",
                    {
                      staticClass: "exam-button-item",
                      on: { click: _vm.closePage },
                    },
                    [_vm._v("关闭")]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }